import { hiddenDown } from '@twistopayments/design-system/styles'

import { Icon } from '../icon'

import * as styles from './link-block.styles'

type LinkBlockProps = {
  headline?: string
  text?: string
  url?: string
  icon?: 'InstallmentsFreeIcon' | 'TwistoOutlineIcon' | 'TwistoPayOutlineIcon'
}

export const LinkBlock = ({ headline, text, icon, url }: LinkBlockProps) => (
  <a css={styles.block} href={url}>
    {icon && (
      <div className="icon" css={styles.icon}>
        <Icon name={icon} size="24" />
      </div>
    )}
    <span className="headline" css={styles.headline}>
      {headline}
    </span>

    <span className="text" css={[styles.text, hiddenDown('smMd')]}>
      {text}
    </span>
  </a>
)
